export default "__VITE_ASSET__DV3CCJAm__"